import { clienteBE } from 'src/app/models/sync.model';
import { OauthService } from './oauth.service';
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
import {  Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { User } from '../models/user.model';
import { StorageService, Session } from './storage.service';
import { db as cedolepdf } from '../cedole.db';
import { db } from '../db';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  public isLoggedIn = new BehaviorSubject(false);
  public user = new Subject<User>();
  public cliente = new Subject<clienteBE>();
  isLoggedIn$ = this.isLoggedIn.asObservable();

  constructor(private oauth: OauthService, private storage: StorageService) { }

  init() {
      const user: User =  this.oauth.getStorageUser();
      this.user.next(user);
      this.isLoggedIn.next(true);
      return user;
  }

  isB2b(): boolean {
    const user: User =  this.oauth.getStorageUser();

    if(user) {
      const info = user.tabinfo.tbr_b2c;
      return (info===' ') ? true : false;
    }
    return false;
  }

  setCliente(cliente: clienteBE | null): void {
    if (cliente) {
      localStorage.setItem('cliente', JSON.stringify(cliente));
    } else {
      localStorage.removeItem('cliente');
    }
    this.cliente.next(cliente);
  }

  getCliente(): clienteBE {
    const cliente: clienteBE = JSON.parse(localStorage.getItem('cliente'));
    return cliente;
  }

  getUser() {
    const user = JSON.parse(localStorage.getItem('user'));
    return user;
  }

  listenCliente(): Observable<clienteBE> {
    return this.cliente.asObservable();
  }
 /**
     * controllo sulla sessione
     */
/*   login(user: User): Promise<User> {

   return this.storage.getSession().then((s: Session) => {
      user.session = (s) ? s : null;  // la sessione dell'utente esiste su questo dispositivo.
      this.oauth.setStorageUser(user);
      this.user.next(user);
      this.isLoggedIn.next(true);
      return user;
    });
  } */

  logout() {
    this.isLoggedIn.next(false);
    this.user.next(null);

    this.oauth.revokeToken();
    this.oauth.clearStorageUser();
  }

  removeUserData() {
    cedolepdf.delete().then((ok) => {
      console.log('delete cedole pdf', ok);
    });
    db.delete().then((ok) => {
      console.log('delete documenti e catalogo', ok);
    });
  }


}
